export default __webpack_public_path__ + "static/media/show-pruner-2.6265a75d.webp";